var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.283,
    height: 27.191,
    viewBox: "678.358 95.809 23.283 27.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Componente 17 \\u2013 4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 1289"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.55 95.81h-8.953a2.235 2.235 0 0 0-2.227 2.237l-.012 17.906c0 1.23.996 2.238 2.227 2.238h13.44a2.245 2.245 0 0 0 2.239-2.238v-13.43l-6.715-6.714Zm2.237 17.905h-8.952v-2.239h8.952v2.239Zm0-4.477h-8.952V107h8.952v2.238Zm-3.357-5.595v-6.155l6.155 6.155h-6.155Z",
    fill: "#603f3f",
    fillRule: "evenodd",
    "data-name": "Tracciato 368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689 115.95a6 6 0 1 1 0 .1",
    fill: "#f7f6f0",
    fillRule: "evenodd",
    "data-name": "Ellisse 10"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 1288"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M698.522 118.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7l3.12 3.12 1.42-1.42-3.12-3.11Zm-3.8.11a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: "#603f3f",
    fillRule: "evenodd",
    "data-name": "Tracciato 367"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.ec84bb128bfbd3a79636ff37b86569de.svg";
export { ForwardRef as ReactComponent };